export default "__VITE_ASSET__CEDy8SoF__"